export default "__VITE_ASSET__parnB$c0__"